// src/data/articles.ts

import { Article } from '../types/Article';
import { iaEntreprises } from './articles/IA-entreprises';
import { tendancesWeb } from './articles/tendances-web';
import etudeCasTransformationComptable from './articles/etude-cas-transformation-comptable-clean';
import optimisationIaEntreprise from './articles/optimisation-ia-entreprise';
import transformationDigitale5Etapes from './articles/transformation-digitale-5-etapes';
import { interviewSanaaMoussaidIA } from './articles/interview-sanaa-moussaid-ia-expertise-comptable';
import { avenirWebTimBernersLeeSolid } from './articles/avenir-web-tim-berners-lee-solid';

// Export le tableau d'articles
export const articles: Article[] = [
    avenirWebTimBernersLeeSolid,
    interviewSanaaMoussaidIA,
    etudeCasTransformationComptable,
    iaEntreprises,
    tendancesWeb,
    optimisationIaEntreprise,
    transformationDigitale5Etapes,
];

// Export individuel si nécessaire
export {
    interviewSanaaMoussaidIA,
    etudeCasTransformationComptable,
    iaEntreprises,
    tendancesWeb,
    optimisationIaEntreprise,
    transformationDigitale5Etapes,
    avenirWebTimBernersLeeSolid,
};
